// Utility functions specific to the app not to framework